 <wiz-vgroup  horizontalAlign="center" verticalAlign="center" width="100%" height="100%"> 
  <wiz-text-area 
  [wizShowLabel]="false"
  [wizValue]="logs"
  width="100%" height="100%"></wiz-text-area>

 </wiz-vgroup>
 
